class ItemTabelasIcmsTabsController extends AbstractController
  @$inject = [ '$scope', 'pathService' ]

  constructor: (@scope, pathService) ->
    @url = pathService.getViewUrl() + 'eficiencia-fiscal/view/configuracao/icms/item-tabelas/tabs/';

    @tabsView = [
      {
        id: 'isensao'
        label: 'Isenção'
        url: @url + 'isencao.html'
        data:
          tipoTabela: 'isencao'
      }
      {
        id: 'substituicaoTributaria'
        label: 'Substituição tributária'
        url: @url + 'substuicao-tributaria.html'
        data:
          tipoTabela: 'substituicao_tributaria'
      }
      {
        id: 'reducao_base_calculo'
        label: 'Redução base cálculo'
        url: @url + 'reducao-base-calculo.html'
        data:
          tipoTabela: 'reducao_base_calculo'
      }
    ]


angular.module("eficienciaFiscalModule").controller('itemTabelasIcmsTabsController', ItemTabelasIcmsTabsController)